import React from "react";
import {useNavigate} from "react-router-dom";

/**
 * Table row that navigates on click. Keep a real <Link> inside it (usually in
 * the first cell): that is what keyboard users, middle/cmd-click and screen
 * readers use, while the row itself is a convenience for the mouse.
 *
 * @param {{to: string, className?: string, children: React.ReactNode}} props
 */
const ClickableRow = ({to, className, children}) => {
    const navigate = useNavigate();

    const handleClick = (event) => {
        // Links and buttons inside the row do their own thing.
        if (event.defaultPrevented || event.target.closest("a, button")) return;
        // Don't navigate away when the user was selecting text.
        if (window.getSelection()?.toString()) return;
        navigate(to);
    };

    return (
        <tr className={className ? `clickable-row ${className}` : "clickable-row"} onClick={handleClick}>
            {children}
        </tr>
    );
};

export default ClickableRow;
